import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// -----------------------------------------------------------

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1080.000000 1080.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN}
          stroke="none"
          strokeWidth="1"
          fillRule="evenodd"
          transform="translate(0.000000,1080.000000) scale(0.100000,-0.100000)"
        >
          <path
            d="M3784 6142 c-61 -37 -119 -73 -128 -81 -14 -12 -16 -56 -16 -437 0
-233 4 -424 8 -424 5 0 59 23 122 51 132 59 130 59 274 -6 55 -25 101 -45 103
-45 2 0 2 196 1 436 l-3 436 -37 22 c-20 11 -72 42 -115 69 -44 26 -84 47 -89
46 -5 0 -59 -30 -120 -67z"
          />
          <path
            d="M2357 6013 c-4 -3 -7 -43 -7 -88 l0 -81 43 -19 c23 -10 71 -32 107
-49 90 -42 124 -39 245 18 55 27 103 53 108 59 10 16 5 167 -6 167 -5 0 -62
-23 -127 -51 l-119 -51 -116 51 c-130 57 -119 53 -128 44z"
          />
          <path
            d="M2352 5608 l3 -91 121 -55 122 -54 67 27 c37 15 96 40 131 57 l64 31
0 88 c0 59 -4 89 -11 89 -6 0 -50 -17 -98 -39 -158 -71 -140 -70 -268 -12 -62
28 -118 51 -123 51 -7 0 -10 -33 -8 -92z"
          />
          <path
            d="M2353 5364 c-3 -9 -3 -118 0 -243 7 -260 23 -340 99 -491 73 -146
244 -297 398 -353 141 -51 209 -62 395 -62 346 0 554 85 732 300 88 107 156
294 169 465 l7 86 -127 54 -126 53 -103 -44 c-161 -68 -150 -59 -163 -139 -15
-90 -47 -154 -104 -211 -57 -57 -121 -86 -217 -101 -211 -31 -388 78 -437 270
-12 43 -16 109 -16 240 0 101 -4 183 -9 187 -5 3 -38 -8 -73 -24 -169 -77
-167 -76 -212 -59 -23 8 -78 31 -124 51 -71 32 -84 34 -89 21z"
          />
          <path
            d="M6355 5271 c-60 -11 -123 -47 -174 -100 -135 -139 -103 -378 65 -480
67 -42 104 -51 196 -51 138 0 243 62 300 177 28 58 33 77 33 143 0 91 -33 168
-97 225 -80 73 -210 107 -323 86z m146 -145 c111 -47 143 -200 61 -292 -15
-17 -37 -36 -49 -42 -28 -15 -118 -15 -146 -1 -72 37 -118 133 -98 205 31 112
136 170 232 130z"
          />
          <path
            d="M7286 5270 l-79 -5 -17 -65 c-10 -36 -34 -128 -55 -205 -44 -171 -44
-169 -52 -162 -3 4 -31 102 -62 219 l-57 213 -87 3 c-48 1 -87 -1 -87 -5 0 -5
46 -146 103 -313 l103 -305 85 -3 84 -3 47 168 c26 92 52 188 59 213 11 42 12
43 22 23 5 -13 33 -107 61 -210 l51 -188 85 -3 86 -3 102 303 c56 167 102 310
102 318 0 12 -14 14 -79 12 l-80 -3 -10 -32 c-5 -18 -30 -111 -56 -207 -59
-222 -54 -209 -65 -190 -4 8 -24 78 -44 155 -20 77 -46 172 -58 210 l-23 70
-79 -5z"
          />
          <path
            d="M7854 5271 c-2 -2 -4 -145 -4 -318 l0 -313 75 0 75 0 2 188 3 187 40
-51 c22 -28 50 -64 62 -80 25 -34 78 -105 141 -186 l43 -58 70 0 69 0 0 314 0
314 -71 4 c-39 2 -73 1 -75 -1 -2 -2 -4 -88 -4 -190 -1 -166 -2 -184 -15 -166
-8 11 -35 47 -60 80 -25 33 -69 92 -98 130 -28 39 -54 72 -57 75 -3 3 -16 19
-28 37 -21 29 -26 32 -93 35 -39 2 -73 1 -75 -1z"
          />
          <path
            d="M4320 5053 c0 -207 1 -220 24 -268 27 -60 77 -106 140 -130 35 -13
66 -16 139 -13 118 5 170 32 225 116 l37 57 3 228 4 227 -86 0 -86 0 0 -213 0
-213 -31 -32 c-26 -26 -39 -32 -76 -32 -24 0 -57 7 -73 15 -55 28 -60 53 -60
275 l0 200 -80 0 -80 0 0 -217z"
          />
          <path
            d="M5000 4955 l0 -315 85 0 84 0 3 87 3 88 43 -3 c68 -5 176 17 219 44
21 14 49 42 63 62 21 32 24 48 25 128 0 82 -3 94 -27 131 -17 26 -45 50 -79
67 -51 25 -58 26 -236 26 l-183 0 0 -315z m335 173 c45 -21 52 -112 10 -153
-21 -22 -33 -25 -100 -25 l-75 0 0 95 0 95 70 0 c38 0 81 -5 95 -12z"
          />
          <path
            d="M5560 5205 l0 -65 95 0 c52 0 94 -3 94 -7 -1 -5 -1 -117 0 -250 l1
-243 80 0 80 0 0 250 0 250 95 0 95 0 0 65 0 65 -270 0 -270 0 0 -65z"
          />
        </g>
      </svg>
    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>;
}
